import { createSelector } from "reselect";

export const entitySelector = createSelector(
    state => state.entityByType,
    state => state
);